<div id="st-map-options-drawer-drawer-backdrop" class="drawer-backdrop" (click)="onClose($event)" (keydown.enter)="onClose($any($event))" (keydown.space)="$event.preventDefault(); onClose($any($event))">
    <div id="st-map-options-drawer-drawer-container" class="drawer-container" (click)="$event.stopPropagation()" (keydown.enter)="$any($event).stopPropagation()" (keydown.space)="$event.preventDefault(); $any($event).stopPropagation()">
        <div id="st-map-options-drawer-drawer-content" class="drawer-content">
            <button class="drawer-option" (click)="onOpenMap('apple', $event)" (keydown.enter)="onOpenMap('apple', $any($event))" (keydown.space)="$event.preventDefault(); onOpenMap('apple', $any($event))" tabindex="0">
                Open in Maps
            </button>
            <div id="st-map-options-drawer-separator" class="separator"></div>
            <button class="drawer-option" (click)="onOpenMap('google', $event)" (keydown.enter)="onOpenMap('google', $any($event))" (keydown.space)="$event.preventDefault(); onOpenMap('google', $any($event))" tabindex="0">
                Open in Google Maps
            </button>
        </div>

        <div id="st-map-options-drawer-drawer-cancel" class="drawer-cancel">
            <button class="cancel-btn" (click)="onClose($event)" (keydown.enter)="onClose($any($event))" (keydown.space)="$event.preventDefault(); onClose($any($event))" tabindex="0">
                Cancel
            </button>
        </div>
    </div>
</div>